import { render, staticRenderFns } from "./dizionarioHtml.vue?vue&type=template&id=16c7eb4b&"
import script from "./dizionarioHtml.vue?vue&type=script&lang=ts&"
export * from "./dizionarioHtml.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports